<template>
  <div
    :id="id ?? 'jss-form-sticky-footer'"
    :class="`flex justify-center h-16 md:h-[68px] w-full left-0 bottom-0 p-3 md:py-3.5 z-[110] transition-all overflow-hidden ${themeClass} ${outsideFormStep ? 'fixed' : 'sticky'}`"
  >
    <div class="max-w-176 w-full justify-between items-center gap-2.5 inline-flex">
      <slot name="start">
        <div class="self-stretch justify-between items-end inline-flex">
          <FormKit
            v-if="!hideDefaultButtons"
            type="button"
            inputClass="btn btn-md btn-secondary"
            label="[Slot = start]"
          />
        </div>
      </slot>
      <slot name="end">
        <FormKit v-if="!hideDefaultButtons" type="button" inputClass="btn btn-md btn-primary" label="[Slot = end]" />
      </slot>
    </div>
  </div>
</template>
<script setup lang="ts">
import { onMounted, ref, onUnmounted, computed, watch } from 'vue';

const resizeObserver = ref<ResizeObserver>();
const screenHeight = ref(window.innerHeight);
const isHidden = ref(true);

const props = defineProps<{
  theme?: 'dark' | 'light';
  id?: string;
  anchorQuerySelector?: string;
  outsideFormStep?: boolean;
  hideDefaultButtons?: boolean;
}>();

const themeClass = computed(() =>
  props.theme == 'light' ? 'bg-white text-racq-dark-greys' : 'bg-racq-navy text-white'
);

onMounted(() => {
  // Move to body level
  if (props.outsideFormStep) {
    const footerEl = document.getElementById(props.id ?? 'jss-form-sticky-footer');
    footerEl && document.body.appendChild(footerEl);
  }

  // Subscribe to window size change
  resizeObserver.value = new ResizeObserver((entries) => {
    screenHeight.value = entries?.[0]?.contentRect?.height || window.innerHeight;
  });

  resizeObserver.value.observe(document.body);

  // Check anchor element
  if (props.anchorQuerySelector) {
    document.addEventListener('scroll', onScroll);
  }
});

onUnmounted(() => {
  resizeObserver.value?.unobserve(document.body);
  document.removeEventListener('scroll', onScroll);
});

watch(isHidden, (newValue) => {
  hideFooter(newValue);
});

const onScroll = () => {
  const anchorEl = document.querySelector(props.anchorQuerySelector!);
  const footerEl = document.getElementById(props.id ?? 'jss-form-sticky-footer');
  if (!anchorEl || !footerEl) return;
  const shouldHide = anchorEl?.getBoundingClientRect().top < footerEl?.getBoundingClientRect().top;
  if (shouldHide != isHidden.value) isHidden.value = shouldHide;
};

function hideFooter(hide: boolean) {
  const footerEl = document.getElementById(props.id ?? 'jss-form-sticky-footer');
  if (!footerEl) return;
  footerEl.style.height = hide ? '0px' : '';
  footerEl.style.padding = hide ? '0px' : '';
}
</script>
